<template>
  <div class="orgBox">
    <!-- <index-title titleText="活跃举办方"></index-title> -->
    <el-row :gutter="15" class="orgCenter">
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <img src="@/assets/images/class.png"/>
          <vue-seamless-scroll :data="librarData" class="seamless-warp">
            <ul class="item">
                <li v-for="item in librarData" :key="item.id">
                  <!-- <span slot="reference"  v-text="item.nick_sponsor" ></span> -->
                  <!--  -->
                  <span v-if="type=='0'" slot="reference"  v-text="item.nick_sponsor" ></span>
                  <span v-if='type==`1`' slot="reference"  v-text="item.join_ogran" ></span>

                  <!-- <el-popover
                  placement="bottom-end"
                  :visible-arrow="false"
                  trigger="hover"
                  :content="`累计${[item.num]}名参赛者`">
                </el-popover> -->
                </li>
            </ul>
        </vue-seamless-scroll>
       </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <img src="@/assets/images/public.png"/>
          <vue-seamless-scroll :data="schoolData" class="seamless-warp">
            <ul class="item">
                <li v-for="item in schoolData" :key="item.id">
                  <!-- <span slot="reference"  v-text="item.nick_sponsor" ></span> -->
                   <span v-if="type=='0'" slot="reference"  v-text="item.nick_sponsor" ></span>
                  <span v-if='type==`1`' slot="reference"  v-text="item.join_ogran" ></span>
                </li>
            </ul>
        </vue-seamless-scroll>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
//    import IndexTitle from '@/components/IndexTitle'
   export default {
        name: 'OrganIndex',
        components: {
        //   IndexTitle
        },
        props:{
          type:{
            type: String,
            default: '0'
          }
        },
        data() {
            return {
              step:1,
              librarData:[],
              schoolData: [],
            }
        },
        filters:{
          filterName(value){
            const rules = {
              0:'nick_sponsor',
              1:'join_ogran',
            }
            return value[rules[this.type]]
          }
        },
        created:function(){
          if(this.type == '0'){
            this.getOrganize();              
          }else if(this.type =='1'){
            // 
            this.getJoinOgran();
          }
        },
        methods: {
          getOrganize(){
              this.$api.loadOrganize().then(res => {
                  //数据处理
                console.log(res.data,"活跃举办方")
                this.librarData = res.data.library;
                this.schoolData = res.data.school;
              }).catch(err => console.log(err))
          },
          async getJoinOgran(){
            try{
              const res = await this.$api.getJoinOgran();
              console.log('this',res)
              this.librarData = res.data.library;
              this.schoolData = res.data.school;
            }catch(err){
              console.log('err',err)
            }
          }
        },
        mounted:function(){

        }
    }
</script>
<style scoped>
  .orgBox{
    text-align: center;
    width: 1200px;
    margin: 0 auto 60px auto;
  }
  .orgCenter{
    width: 1200px;
    margin: 0 auto;
  }
  .grid-content{
    height: 500px;
    background: #FFFFFF;
    border-radius: 10px 10px 0px 0px;
  }
  .grid-content img{
    width: 100%;
    height: 98px;
  }
  .seamless-warp {
    height:350px;
    overflow: hidden;
    cursor: pointer;
    margin: 20px 0px ;
    box-sizing: border-box;
  }
  .seamless-warp ul li span{
    display: inline-block;
    width: 90%;
    font-size: 16px;
    line-height: 40px;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    margin: 0 auto;
  }
  .seamless-warp ul li span:hover{
    color: #3370ff;
  }

</style>



// WEBPACK FOOTER //
// src/pages/home/components/activeOriganizer.vue